/** API route map: URLS.Controller.CandidateNotes */
export const CandidateNotes = {
      Name: 'CandidateNotes/',
      GetAllNote: 'candidate-notes',
      AddNote: 'add-candidate-note',
      UpdateCandidateNote: 'update',
      DeleteCandidateNote: 'delete',
      ShareCandidateNote: 'share',
};
